<div>
    <div class="row">
        <div class="col-12 my-3">
            <span class="addressTitle muted-color"> {{ 'ADDRESS.LABEL1' | translate }} </span>
        </div>
        <div class="col-12">
            <span class="addressText muted-color"> {{ 'ADDRESS.LABEL2' | translate }} </span>
        </div>

        <form [formGroup]="formGroup">
        <div class="col-12">
            <mat-card class="addressCard">
                <mat-card-content>

                    <div class="row">

                        <div class="col-sm-12 col-md-4">
                            <mat-form-field appearance="outline" floatLabel="always" class="w-100">
                              <mat-label> {{ 'ADDRESS.LABEL3' | translate }} </mat-label>
                              <input maxlength="5" matInput placeholder="" formControlName="postalCode" onpaste="return false"  (keypress)="commonService.validateNo($event)" (change)="searchDataFromZipCode()"/>
                              <mat-error *ngIf="formControls['postalCode'].errors?.['minlength']"> {{ 'ADDRESS.LABEL4' | translate }} </mat-error>
                            </mat-form-field>
                        </div>

                        <div class="col-sm-12 col-md-4">
                            <mat-form-field appearance="outline" floatLabel="always" class="w-100">
                            <mat-label> {{ 'ADDRESS.LABEL5' | translate }} </mat-label>
                            <input matInput placeholder="" formControlName="state" onpaste="return false"  (keypress)="commonService.validateCa($event)"/>
                            </mat-form-field>
                        </div>

                        <div class="col-sm-12 col-md-4">
                            <mat-form-field appearance="outline" floatLabel="always" class="w-100">
                            <mat-label> {{ 'ADDRESS.LABEL6' | translate }} </mat-label>
                            <input matInput placeholder="" formControlName="mayoralty" onpaste="return false"  (keypress)="commonService.validateCa($event)"/>
                            </mat-form-field>
                        </div>

                    </div>

                    <div class="row">

                        <div class="col-sm-12 col-md-4">
                            <mat-form-field appearance="outline" floatLabel="always" class="w-100">
                              <mat-label> {{ 'ADDRESS.LABEL7' | translate }} </mat-label>
                              <mat-select formControlName="neighborhood">
                                <ng-container *ngFor="let colonia of colonias">

                                    <mat-option [value]="colonia.nombre" *ngIf="colonia.nombre !== ''; else tmpDefaultValue">{{ colonia.nombre }}</mat-option>
                                    <ng-template #tmpDefaultValue>
                                        <mat-option [value]="''"> {{ 'ADDRESS.LABEL8' | translate }} </mat-option>
                                    </ng-template>
                                </ng-container>
                              </mat-select>
                            </mat-form-field>
                          </div>

                        <!-- <div class="col-sm-12 col-md-4">
                          <mat-form-field appearance="outline" floatLabel="always" class="w-100">
                            <mat-label>Colonia</mat-label>
                            <input matInput placeholder="" formControlName="neighborhood" onpaste="return false"  (keypress)="commonService.validateCa($event)"/>
                          </mat-form-field>
                        </div> -->

                        <div class="col-sm-12 col-md-4">
                            <mat-form-field appearance="outline" floatLabel="always" class="w-100">
                                <mat-label> {{ 'ADDRESS.LABEL9' | translate }} </mat-label>
                                <input matInput placeholder="" formControlName="street" onpaste="return false" (keypress)="commonService.validateSpecialCharDescription($event)"/>
                            </mat-form-field>
                        </div>

                        <div class="col-sm-12 col-md-4">
                            <mat-form-field appearance="outline" floatLabel="always" class="w-100">
                                <mat-label> {{ 'ADDRESS.LABEL10' | translate }} </mat-label>
                                <input matInput placeholder="" formControlName="externalNumber" onpaste="return false" (keypress)="commonService.validateSpecialCharDescription($event)"/>
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-sm-12 col-md-4">
                            <mat-form-field appearance="outline" floatLabel="always" class="w-100">
                                <mat-label> {{ 'ADDRESS.LABEL11' | translate }} </mat-label>
                                <input matInput placeholder="" formControlName="internalNumber" onpaste="return false" (keypress)="commonService.validateSpecialCharDescription($event)"/>
                            </mat-form-field>
                        </div>
                    </div>

                </mat-card-content>
            </mat-card>
            <div class="d-none d-sm-none d-md-flex justify-content-end my-5">
                <button class="w-25 p-1" type="button" (click)="stepBack()" mat-raised-button
                    color="accent"> {{ 'ADDRESS.LABEL12' | translate }} </button>
                <button class="w-25 p-1 mx-2" type="submit" (click)="stepOn()" mat-raised-button
                    color="primary"> {{ 'ADDRESS.LABEL13' | translate }} </button>
            </div>
            <div class="d-block d-sm-block d-md-none">
                <mat-card class="serviceCard my-3">
                    <mat-card-content>
                        <button class="w-100 p-1 mx-2" type="submit" (click)="stepOn()" mat-raised-button
                            color="primary"> {{ 'ADDRESS.LABEL14' | translate }} </button>
                    </mat-card-content>
                </mat-card>
            </div>
        </div>
    </form>
    </div>
</div>